import React, {useEffect, useState} from 'react';
import {Navigate, Outlet, useLocation} from 'react-router-dom';
import {authStorage, ensureAuthenticated} from '../../services/api';

export default function ProtectedRoute() {
    const location = useLocation();
    const [authState, setAuthState] = useState(() => authStorage.isAuthenticated() ? 'authenticated' : 'checking');

    useEffect(() => {
        let active = true;
        const restoreSession = async () => {
            const authenticated = await ensureAuthenticated();
            if (active) setAuthState(authenticated ? 'authenticated' : 'anonymous');
        };
        const syncAuth = () => {
            if (authStorage.isAuthenticated()) setAuthState('authenticated');
            else if (authStorage.get().refresh) { setAuthState('checking'); restoreSession(); }
            else setAuthState('anonymous');
        };
        window.addEventListener('auth-change', syncAuth);
        window.addEventListener('storage', syncAuth);
        restoreSession();
        return () => {
            active = false;
            window.removeEventListener('auth-change', syncAuth);
            window.removeEventListener('storage', syncAuth);
        };
    }, []);

    if (authState === 'checking') return <div className="api-message">در حال بازیابی نشست کاربری...</div>;
    return authState === 'authenticated'
        ? <Outlet/>
        : <Navigate to="/login" replace state={{from: `${location.pathname}${location.search}`}}/>;
}
